/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Section_Steps_AccentInputs */

const en_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every lesson.`)
};

const es_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada lección.`)
};

const de_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In jeder Golfstunde.`)
};

const zh_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每节课。`)
};

const ar_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`في كل درس.`)
};

const fr_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque leçon.`)
};

const vi_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mỗi bài học.`)
};

const sw_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kila somo.`)
};

const th_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทุกบทเรียน`)
};

const bs_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svaka lekcija.`)
};

const ja_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのレッスンで。`)
};

const ko_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매 레슨마다.`)
};

const pt_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em todas as aulas.`)
};

const it_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni lezione.`)
};

const sv_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varje lektion.`)
};

const nl_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke les.`)
};

const da_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hver lektion.`)
};

const nb_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hver leksjon.`)
};

const fi_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jokainen oppitunti.`)
};

const pl_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każda lekcja.`)
};

const ru_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каждый урок.`)
};

const tr_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her ders.`)
};

const hi_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रत्येक पाठ`)
};

const id_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap pelajaran.`)
};

const ms_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap pelajaran.`)
};

const cs_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Každou lekci.`)
};

const el_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κάθε μάθημα.`)
};

const he_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כל שיעור.`)
};

const af_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke les.`)
};

const hu_home_section_steps_accent = /** @type {(inputs: Home_Section_Steps_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden lecke.`)
};

/**
* | output |
* | --- |
* | "Every lesson." |
*
* @param {Home_Section_Steps_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_section_steps_accent = /** @type {((inputs?: Home_Section_Steps_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Section_Steps_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_section_steps_accent(inputs)
	if (locale === "de") return de_home_section_steps_accent(inputs)
	if (locale === "zh") return zh_home_section_steps_accent(inputs)
	if (locale === "ar") return ar_home_section_steps_accent(inputs)
	if (locale === "fr") return fr_home_section_steps_accent(inputs)
	if (locale === "vi") return vi_home_section_steps_accent(inputs)
	if (locale === "sw") return sw_home_section_steps_accent(inputs)
	if (locale === "th") return th_home_section_steps_accent(inputs)
	if (locale === "bs") return bs_home_section_steps_accent(inputs)
	if (locale === "ja") return ja_home_section_steps_accent(inputs)
	if (locale === "ko") return ko_home_section_steps_accent(inputs)
	if (locale === "pt") return pt_home_section_steps_accent(inputs)
	if (locale === "it") return it_home_section_steps_accent(inputs)
	if (locale === "sv") return sv_home_section_steps_accent(inputs)
	if (locale === "nl") return nl_home_section_steps_accent(inputs)
	if (locale === "da") return da_home_section_steps_accent(inputs)
	if (locale === "nb") return nb_home_section_steps_accent(inputs)
	if (locale === "fi") return fi_home_section_steps_accent(inputs)
	if (locale === "pl") return pl_home_section_steps_accent(inputs)
	if (locale === "ru") return ru_home_section_steps_accent(inputs)
	if (locale === "tr") return tr_home_section_steps_accent(inputs)
	if (locale === "hi") return hi_home_section_steps_accent(inputs)
	if (locale === "id") return id_home_section_steps_accent(inputs)
	if (locale === "ms") return ms_home_section_steps_accent(inputs)
	if (locale === "cs") return cs_home_section_steps_accent(inputs)
	if (locale === "el") return el_home_section_steps_accent(inputs)
	if (locale === "he") return he_home_section_steps_accent(inputs)
	if (locale === "af") return af_home_section_steps_accent(inputs)
	if (locale === "hu") return hu_home_section_steps_accent(inputs)
	return en_home_section_steps_accent(inputs)
});